import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customDate'
})
export class CustomDatePipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    if (typeof value != 'string') {
      return value;
    }
    if (!value || (value && !value.length)) {
      return '';
    }

    const lastLetter = value.slice(-1);
    const hasZ = lastLetter === 'z' || lastLetter === 'Z';

    return hasZ ? value : `${value}z`;
  }
}
